import React from "react";
import PropTypes from "prop-types";
const TotalArchivos = ({
  error = 0,
  pendientes = 0,
  completo = 0,
  enProceso = 0
}) => {
  return (
    <>
      <div className="col-md-6 col-xl-3 mb-4 animated--grow-in">
        <div
          className="card shadow border-start-warning py-2"
          data-bss-hover-animate="pulse"
        >
          <div className="card-body">
            <div className="row align-items-center no-gutters">
              <div className="col me-2">
                <div className="text-uppercase text-warning fw-bold text-xs mb-1">
                  <span>Pendientes</span>
                </div>
                <div className="text-secondary fw-bold h5 mb-0">
                  <span>{pendientes}%</span>
                </div>
              </div>
              <div className="col-auto">
                <i className="fas fa-clipboard-list text-warning text-bg-warning fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
          <div className="progress progress-sm">
            <div
              className="progress-bar bg-info bg-warning"
              aria-valuenow="15"
              aria-valuemin="0"
              aria-valuemax="100"
              style={{ width: pendientes + "%" }}
            >
              <span className="visually-hidden">15%</span>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-6 col-xl-3 mb-4 animated--grow-in">
        <div
          className="card shadow border-start-warning py-2"
          data-bss-hover-animate="pulse"
        >
          <div className="card-body">
            <div className="row align-items-center no-gutters">
              <div className="col me-2">
                <div className="text-uppercase text-warning fw-bold text-xs mb-1">
                  <span>En proceso</span>
                </div>
                <div className="text-secondary fw-bold h5 mb-0">
                  <span>{enProceso}%</span>
                </div>
              </div>
              <div className="col-auto">
                <i className="fas fa-clipboard-list text-warning text-bg-warning fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
          <div className="progress progress-sm">
            <div
              className="progress-bar bg-info bg-warning"
              aria-valuenow="15"
              aria-valuemin="0"
              aria-valuemax="100"
              style={{ width: pendientes + "%" }}
            >
              <span className="visually-hidden">15%</span>
            </div>
          </div>
        </div>
      </div>
      <div
        className="col-md-6 col-xl-3 mb-4 animated--grow-in"
        data-bss-hover-animate="pulse"
      >
        <div
          className="card shadow border-start-success py-2"
          data-bss-hover-animate="pulse"
        >
          <div className="card-body">
            <div className="row align-items-center no-gutters">
              <div className="col me-2">
                <div className="text-uppercase text-danger fw-bold text-xs mb-2">
                  <span>ERROR</span>
                </div>
                <div className="text-secondary fw-bold h5 mb-0">
                  <span>{error + "%"}</span>
                </div>
              </div>
              <div className="col-auto">
                <i className="fas fa-clipboard-list text-bg-danger fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
          <div className="progress progress-sm">
            <div
              className="progress-bar bg-danger bg-success"
              aria-valuenow="50"
              aria-valuemin="0"
              aria-valuemax="100"
              style={{ width: error + "%" }}
            >
              <span className="visually-hidden">50%</span>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-6 col-xl-3 mb-4 animated--grow-in">
        <div
          className="card shadow border-start-success py-2"
          data-bss-hover-animate="pulse"
        >
          <div className="card-body">
            <div className="row align-items-center no-gutters">
              <div className="col me-2">
                <div className="text-uppercase text-success fw-bold text-xs mb-2">
                  <span>COMPLETO</span>
                </div>
                <div className="text-secondary fw-bold h5 mb-0">
                  <span>{completo}%</span>
                </div>
              </div>
              <div className="col-auto">
                <i className="fas fa-clipboard-list text-success text-bg-success border rounded fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
          <div className="progress progress-sm">
            <div
              className="progress-bar bg-success bg-success"
              aria-valuenow="80"
              aria-valuemin="0"
              aria-valuemax="100"
              style={{ width: completo + "%" }}
            >
              <span className="visually-hidden">80%</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
TotalArchivos.prototype = {
  error: PropTypes.number.isRequired,
  pendientes: PropTypes.number.isRequired,
  completo: PropTypes.number.isRequired
};

export default TotalArchivos;
